import { takeEvery, all, put, call } from 'redux-saga/effects';
import * as calls from './calls';
import * as reducerActions from '../../reducers/ConfigGlobalReducer/actions';
import * as Notification from '../../components/Common/notification';
import * as layoutActions from '../../reducers/layoutReducer/actions';

function* genFetchConfigVidriera() {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando configuración de vidriera...' }));

        // Llamar a la acción que obtiene la configuración de vidriera
        const vidriera = yield call(calls.getConfigVidriera);

        // Actualizar el estado con el resultado
        yield put(reducerActions.fetchConfigVidrieraSuccess(vidriera));
    } catch (error) {
        Notification.showError(error.error || 'Error al cargar la configuración de vidriera');

        // Actualizar el estado con el error
        yield put(reducerActions.fetchConfigVidrieraFailure(error));
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genPutTokenFeedbackSmile(action) {
    try {
        yield put(
            layoutActions.setLoading({ 
                show: true, 
                message: 'Guardando token Feedback Smile...' 
            })
        );

        // Llamar a la función que guarda el token en el backend
        yield call(calls.updateConfigFeedback, action.payload.tokenFeedbackSmile);

        // Notificar éxito
        Notification.showSuccess('Token Feedback Smile guardado correctamente.');
    } catch (error) {
        Notification.showError('Error al guardar el token Feedback Smile.');
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* defaultSaga() {
    yield all([
        takeEvery(reducerActions.FETCH_CONFIG_VIDRIERA, genFetchConfigVidriera),
        takeEvery(reducerActions.SET_TOKEN_FEEDBACK_SMILE, genPutTokenFeedbackSmile),
    ]);
}

export const sagas = [
    defaultSaga,
];
